// extracted by mini-css-extract-plugin
export default {"modal":"ModalCrop_modal__k4Yox","modal_content":"ModalCrop_modal_content__MBkGv"};